type SentryEnvironment = 'staging' | 'production';

type Integration = { name: string; enableScreenshot?: boolean };

type IntegrationFactories = {
  browserSessionIntegration: () => Integration;
  browserTracingIntegration: () => Integration;
  browserProfilingIntegration: () => Integration;
  feedbackIntegration: (options: {
    colorScheme: 'light';
    showBranding: false;
    enableScreenshot: false;
  }) => Integration;
  consoleLoggingIntegration: (options: { levels: Array<'warn' | 'error'> }) => Integration;
};

type SampleRates = {
  tracesSampleRate: number;
  profilesSampleRate: number;
};

export function buildSentryOptions(
  environment: SentryEnvironment,
  integrations: IntegrationFactories,
  sampleRates: SampleRates = {
    tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
    profilesSampleRate: environment === 'production' ? 0.2 : 1.0,
  },
) {
  return {
    ...sampleRates,
    integrations: [
      integrations.browserSessionIntegration(),
      integrations.browserTracingIntegration(),
      integrations.browserProfilingIntegration(),
      integrations.feedbackIntegration({
        colorScheme: 'light',
        showBranding: false,
        enableScreenshot: false,
      }),
      integrations.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    ],
  };
}

type SentryEvent = { request?: { data?: unknown } };

export function scrubSentryEvent<T extends SentryEvent>(event: T): T {
  if (event.request?.data && typeof event.request.data === 'object') {
    const scrubbed = { ...event.request.data } as Record<string, unknown>;
    for (const key of ['password', 'token', 'secret', 'accessToken', 'refreshToken', 'authorization']) {
      if (key in scrubbed) scrubbed[key] = '[Filtered]';
    }
    event.request.data = scrubbed;
  }
  return event;
}
